import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { cashOnDeliveryUpdate } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api'
import {
  CashOnDeliveryEditIntegrationInterface,
  CashOnDeliveryErrorsIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types'
import React, { useState } from 'react'
import EditModal from 'shared/components/edit-modal'
import FormTextarea from 'shared/components/form-textarea'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

interface CashOnDeliveryEditModalProps {
  instructions: string | null
}

const defaultErrors: CashOnDeliveryErrorsIntegrationInterface = {
  instructions: '',
}

const CashOnDeliveryEditModal = ({ instructions }: CashOnDeliveryEditModalProps) => {
  const { t } = useLocoTranslation()

  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)

  const [tempState, setTempState] = useState({ instructions: instructions || '' })

  const { mutatePaymentIntegrations } = useConnectedPaymentIntegrations()

  const onUpdate = async (data: CashOnDeliveryEditIntegrationInterface) => {
    await fetchWithErrors(async () => {
      await cashOnDeliveryUpdate(data)
      await mutatePaymentIntegrations()
    }, setErrors)
  }

  return (
    <>
      <button className={'primary-link'} onClick={() => setOpened(true)}>
        {t('dashboard.settings.payment-gateways.edit_cash_on_delivery_instructions')}
      </button>
      <EditModal
        fullCaption={t('dashboard.settings.payment-gateways.edit_cash_on_delivery_instructions')}
        opened={opened}
        onClose={() => {
          setOpened(false)
        }}
        instance={tempState}
        editable={[
          {
            field: 'instructions',
            onRender: (value, onChange, _, __, isPreFetching) => (
              <FormTextarea
                key="cash-on-delivery-edit-instructions"
                label={t('dashboard.settings.payment-gateways.instructions_title')}
                isLoading={isPreFetching}
                onChange={e => {
                  setTempState(prev => {
                    return { ...prev, instructions: e.target.value }
                  })
                  onChange(e.target.value)
                }}
                value={value || ''}
                error={errors.instructions}
                className={'min-h-[126px]'}
              />
            ),
          },
        ]}
        onEdit={data => onUpdate(data)}
      />
    </>
  )
}

export default CashOnDeliveryEditModal
